// native
import { Component, OnInit } from '@angular/core';

// service
import { MatcherService } from '../../../core/services/matcher.service';
import { ItemsDisplayService } from '../../../core/services/items-display.service';

// models
import { IDisplayItem } from '../../../models';

@Component({
  selector: 'scs-matcher',
  templateUrl: './matcher.component.html'
})
export class MatcherComponent implements OnInit {

  itemsToMatch: IDisplayItem[] = [];
  currentItemIndex = 0;
  currentItem: IDisplayItem;

  constructor(
    private matcherService: MatcherService,
    public itemsDisplayService: ItemsDisplayService
  ) { }

  ngOnInit(): void {
    this.matcherService.itemsToMatch$.subscribe((items: any) => {

      this.itemsToMatch = items;
      this.currentItem = this.itemsToMatch[0];
      this.matcherService.currentItem$.next(this.currentItem);
    });
  }

  onMatcherInfoClick() { }

  onItemMatched(matchedItemId: string) {
    this.matcherService.addMatch(this.itemsToMatch[this.currentItemIndex].import_data?.original_id, matchedItemId);

    if (this.currentItemIndex >= (this.itemsToMatch.length - 1)) {
      this.closeMatcher();
      return;
    }
    
    this.switchToNextItem();
  }

  onMatchNotFound() {
    if (this.currentItemIndex >= (this.itemsToMatch.length - 1)) {
      this.closeMatcher();
      return;
    }

    this.switchToNextItem();
  }

  private switchToNextItem() {
    this.currentItemIndex++;
    this.currentItem = this.itemsToMatch[this.currentItemIndex];
    this.matcherService.currentItem$.next(this.currentItem);
  }

  private closeMatcher() {
    this.matcherService.allItemsIdsMatched$.next(this.matcherService.itemsIdsMatched);
    this.matcherService.itemsToMatch$.next([]);
    this.matcherService.itemsIdsMatched = [];
  }
}
